import { render, staticRenderFns } from "./wishingPoolRecord.vue?vue&type=template&id=2e250f52&scoped=true"
import script from "./wishingPoolRecord.vue?vue&type=script&lang=js"
export * from "./wishingPoolRecord.vue?vue&type=script&lang=js"
import style0 from "./wishingPoolRecord.vue?vue&type=style&index=0&id=2e250f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e250f52",
  null
  
)

export default component.exports